import React, { useEffect } from "react";
import Login from "../Auth/Login";
import { Navigate, useLocation, useRoutes } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";
import TenantDetail from "../TenantDetail/TenantDetail";
import AppLayout from "../AppLayout/AppLayout";
import NotFoundPage from "../Common/NotFoundPage";
import FaviconLogo from "../../assets/images/learnifyIcon.png"
import Courses from "../Courses/Courses";
import TenantAccess from "../TenantDetail/TenantAccess";
import CourseAccess from "../Courses/CourseAccess";

const ProtectedRoute = ({ children }) => {
    const favicon = document.querySelector('link[rel="icon"]');
    const shortcutIcon = document.querySelector('link[rel="shortcut icon"]');

    if (favicon) {
        favicon.href = FaviconLogo;
    }
    if (shortcutIcon) {
        shortcutIcon.href = FaviconLogo;
    }


    const isAuthenticated = !!localStorage.getItem("token");

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    
    return children;
};

const RoutesComponent = () => {
    const location = useLocation();

    const appRoutes = [
        { path: "/login", element: <Login />, title: "Login | Multi-Tenant Learnify" },
        { 
            path: "/",
            element: <ProtectedRoute><AppLayout /></ProtectedRoute>,
            children: [
                { path: "dashboard", element: <Dashboard />, title: "Dashboard | Multi-Tenant Learnify" },
                { path: "courses", element: <Courses />, title: "Courses | Multi-Tenant Learnify" },
                { path: "courses/access/:id", element: <CourseAccess />, title: "Course Access | Multi-Tenant Learnify" },
                { path: "customer/access/:id", element: <TenantAccess />, title: "Customer Access | Multi-Tenant Learnify" },
                { path: "customer/detail", element: <TenantDetail />, title: "Customer Detail | Multi-Tenant Learnify" },
            ]
         },        
        {
            path: "*", element: <NotFoundPage/>, title: "Page not found | Multi-Tenant Learnify"
        }
    ];

    const findRouteTitle = (routes, path) => {
        for (const route of routes) {
            if (route.path === path) {
                return route.title;
            }
            if (route.children) {
                const childTitle = findRouteTitle(route.children, path.replace(/^\//, ''));
                if (childTitle) {
                    return childTitle;
                }
            }
        }
        return null;
    };

    useEffect(() => {
        const currentTitle = findRouteTitle(appRoutes, location.pathname);
        document.title = currentTitle || "Multi - Tenant LMS | Dashboard";
    }, [location]);

    useEffect(() => {
        const favicon = document.querySelector('link[rel="icon"]');
        const shortcutIcon = document.querySelector('link[rel="shortcut icon"]');

        if (favicon) {
            favicon.href = FaviconLogo;
        }
        if (shortcutIcon) {
            shortcutIcon.href = FaviconLogo;
        }
    }, []);

    return useRoutes(appRoutes)
};

export default RoutesComponent;